import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-queue-transfer-popup',
    templateUrl: './queue-transfer-popup.component.html',
    styleUrls: ['./open-scape.component.scss']
  })

  export class QueueTransferPopupComponent implements OnInit {

    queue = []; 
    constructor() {}

    ngOnInit(): void {

    }

  }